import {useTranslation} from "react-i18next";
import React from "react";
import {Col, Form} from "react-bootstrap";
import {Block, BoolSelect, FormGroup, Select, ZoneForm} from "../components";
import { useGetZonesQuery } from "../../api/zoneApiSlice";

export default function ZonesAssociationForm({formData, getInputProps, disabled, useParentFormRef, formKey}) {
  const { t } = useTranslation();
  const {data: zones = [], isError, isSuccess, refetch} = useGetZonesQuery()

  return <React.Fragment>
    <Block title={t("stream.geography.allEventsSection")}>
      <Form.Row>
        <FormGroup input={BoolSelect} as={Col} md={6} label={t("stream.geography.filter")} {...getInputProps("event_filter")}/>
        { formData.event_filter && formData.traces && <FormGroup
          as={Col}
          md={6}
          label={t("stream.geography.trace_filter_type")}
          text={t("stream.geography.trace_filter_type_text")}
          {...getInputProps("traces_zone_type")}>
          <Select>
            <Option value="start">{t("stream.geography.trace_filter_type.start")}</Option>
            <Option value="end">{t("stream.geography.trace_filter_type.end")}</Option>
            <Option value="startorend">{t("stream.geography.trace_filter_type.startorend")}</Option>
            <Option value="intersect">{t("stream.geography.trace_filter_type.intersect")}</Option>
          </Select>
        </FormGroup>}
      </Form.Row>
      {formData.event_filter && <Form.Row>
        <FormGroup as={Col} md={6} label={t("stream.geography.useExistingZone")} {...getInputProps("use_existing_event_zone")}>
          <BoolSelect yes={t("stream.geography.useExisting")} no={t("stream.geography.createNewZone")} />
        </FormGroup>
      </Form.Row>}
      {formData.event_filter && formData.use_existing_event_zone && <FormGroup label={t("stream.geography.zones")} {...getInputProps("event_zone_ids")}>
        <Select isMulti options={zones.map( zone => ({value: zone.key, label: zone.name}))} />
      </FormGroup>}
      {formData.event_filter && formData.use_existing_event_zone === false && <ZoneForm
        zone={formData.event_zone}
        refreshKey={formKey}
        disabled={disabled}
        parentFormRef={useParentFormRef("event_zone")}
        fromStream={true} />}
    </Block>
    <Block title={t("stream.geography.homeSection")}>
      <Form.Row>
        <FormGroup input={BoolSelect} as={Col} md={6} label={t("stream.geography.homeFilter")} {...getInputProps("home_filter")}/>
      </Form.Row>
      {formData.home_filter && <Form.Row>
        <FormGroup as={Col} md={6} label={t("stream.geography.useExistingZone")} {...getInputProps("use_existing_home_zone")}>
          <BoolSelect yes={t("stream.geography.useExisting")} no={t("stream.geography.createNewZone")} />
        </FormGroup>
      </Form.Row>}
      {formData.home_filter && formData.use_existing_home_zone && <FormGroup label={t("stream.geography.zones")} {...getInputProps("home_zone_ids")}>
        <Select isMulti options={zones.map( zone => ({value: zone.key, label: zone.name}))} />
      </FormGroup>}
      {formData.home_filter && formData.use_existing_home_zone === false && <ZoneForm
        zone={formData.home_zone}
        refreshKey={formKey}
        disabled={disabled}
        parentFormRef={useParentFormRef("home_zone")}
        fromStream={true} />}
    </Block>
    <Block title={t("stream.geography.workSection")}>
      <Form.Row>
        <FormGroup input={BoolSelect} as={Col} md={6} label={t("stream.geography.workFilter")} {...getInputProps("work_filter")}/>
      </Form.Row>
      {formData.work_filter && <Form.Row>
        <FormGroup as={Col} md={6} label={t("stream.geography.useExistingZone")} {...getInputProps("use_existing_work_zone")}>
          <BoolSelect yes={t("stream.geography.useExisting")} no={t("stream.geography.createNewZone")} />
        </FormGroup>
      </Form.Row>}
      {formData.work_filter && formData.use_existing_work_zone && <FormGroup label={t("stream.geography.zones")} {...getInputProps("work_zone_ids")}>
        <Select isMulti options={zones.map( zone => ({value: zone.key, label: zone.name}))} />
      </FormGroup>}
      {formData.work_filter && formData.use_existing_work_zone === false && <ZoneForm
        zone={formData.work_zone}
        refreshKey={formKey}
        disabled={disabled}
        parentFormRef={useParentFormRef("work_zone")}
        fromStream={true} />}
    </Block>
  </React.Fragment>
}
